import React from 'react';
import { createPortal } from 'react-dom';
import ObiettiviManager from './ObiettiviManager';

/* Finestra wizard: contenitore attorno a ObiettiviManager (gestione obiettivi/priorità). */
export default function ObiettiviWizard({ open, onClose }) {
  if (!open) return null;
  return createPortal(
    <div className="ob-overlay" onClick={onClose}>
      <div className="ob-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ob-head">
          <span>Obiettivi &amp; priorità</span>
          <button className="ob-x" onClick={onClose}>✕</button>
        </div>
        <ObiettiviManager />
      </div>
    </div>,
    document.body
  );
}
